import styles from './index.module.sass';
import { useStore } from 'effector-react';
import { $selectedLeftWh, $selectedRightWh } from '@/widgets/storage-viewer/model';
import closeIcon from '@@/mixing/images/close.icon.svg';
import { Tooltip } from 'antd';
import questionSvg from '@@/mixing/images/question.svg';
import classNames from 'classnames';
import { TooltipCardHeader } from '../tooltip-card-header';
import { ITotalData } from '@/modules/mixing/ts/rustmix-buyer.types';

export const CardHeader = ({
  profitSum,
  title,
  color,
  classNumber,
  pricePerTon,
  sum,
  selectSourceFx,
  expertMode,
  selectedBagId,
  id,
  clearBag,
  weight,
  targetMoistureData,
  totalData,
}: IArgs) => {
  const selectedWh = useStore(id === 1 ? $selectedLeftWh : $selectedRightWh);
  return (
    <>
      <div
        className={styles.head}
        style={{
          backgroundColor: title === 'результат миксования' ? '#E1F3EA' : '#fff',
          borderBottom: `2px solid ${
            color === 'red' ? '#E73A42' : color === 'green' ? '#66B28A' : '#409BFF'
          }`,
          borderColor:
            color === 'red' ? '#E73A42' : color === 'green' ? '#66B28A' : '#409BFF',
        }}
      >
        <span
          className={styles.label}
          style={{
            color:
              color === 'red' ? '#E73A42' : color === 'green' ? '#007E3C' : '#0870E2',
          }}
        >
          {title}
        </span>
        <span className={styles.sum}>
          {isNaN(sum)
            ? 'цена отсутствует'
            : `${Number(sum.toFixed(1)).toLocaleString('RU-ru')} ₽` || ''}{' '}
          <span
            className={styles.additionalProfit}
            // style={{
            //   opacity: expertMode ? '1' : '0',
            //   visibility: expertMode ? 'visible' : 'hidden',
            // }}
          >
            <Tooltip
              arrow={false}
              overlayStyle={{ color: '#000', minWidth: 350 }}
              color="#fff"
              title={
                <TooltipCardHeader
                  sum={sum}
                  classNumber={classNumber}
                  weight={weight}
                  targetMoistureData={targetMoistureData}
                  pricePerTon={pricePerTon}
                  profitSum={profitSum}
                  totalData={totalData}
                  cardIdx={id}
                />
              }
            >
              <img className={styles.questionIcon} src={questionSvg} />
            </Tooltip>
          </span>
        </span>
        <div className={styles.classNprice}>
          <div className={styles.classData}>
            <span>
              {classNumber > 0 && weight > 0
                ? `${classNumber}й класс`
                : 'класс не определен'}
            </span>
            <strong>
              {pricePerTon ? pricePerTon.toLocaleString('RU-ru') + ' ₽/т' : ''}
            </strong>
          </div>
          {profitSum && !!totalData.bagAPrice && !!totalData.bagBPrice ? (
            <div className={styles.profitSum}>
              <div
                className={styles.roundDeco}
                style={
                  +profitSum < 0
                    ? { background: 'linear-gradient(45deg, #E73A42, #871E23)' }
                    : {}
                }
              ></div>
              <div className={styles.profitText}>
                <span> {+profitSum > 0 ? 'выгода:' : 'убыток:'}</span>
                <span>
                  {+profitSum > 0
                    ? `+${profitSum?.toLocaleString('RU-ru')} ₽`
                    : `${profitSum?.toLocaleString('RU-ru')} ₽`}{' '}
                </span>
              </div>
            </div>
          ) : (
            title !== 'результат миксования' && (
              <>
                <div
                  className={classNames(
                    styles.sourceBadge,
                    !selectedWh && styles.selectSourceButton,
                  )}
                  style={{ display: 'flex', gap: '3px' }}
                >
                  <div
                    className={styles.badgeWrap}
                    style={{ display: 'flex', gap: '3px' }}
                    onClick={() => selectSourceFx && selectSourceFx()}
                  >
                    {selectedWh && (
                      <>
                        {selectedWh?.name.length < 20 ? (
                          <a
                            className={styles.selectedSource}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {selectedWh?.name}
                          </a>
                        ) : (
                          <Tooltip title={selectedWh?.name} color="#000">
                            <a
                              className={styles.selectedSource}
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {`${selectedWh?.name.substr(0, 20)}...`}
                            </a>
                          </Tooltip>
                        )}
                      </>
                    )}

                    <div className={styles.lowerLine}>
                      <a
                        className={classNames(styles.selectSource)}
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {selectedBagId && selectedBagId !== ''
                          ? selectedBagId
                          : 'выбрать источник'}
                      </a>
                      {selectedBagId && (
                        <span className={styles.selectSource}>
                          вес: <span>{weight} т</span>
                        </span>
                      )}
                    </div>
                  </div>
                  {selectedWh && (
                    <img
                      className={styles.clearBtn}
                      src={closeIcon}
                      onClick={clearBag}
                    />
                  )}
                </div>
              </>
            )
          )}
        </div>
      </div>
    </>
  );
};

interface IArgs {
  id?: number;
  profitSum?: string | number;
  title: string;
  color: string;
  classNumber: number;
  pricePerTon: number;
  sum: number;
  selectSourceFx?: () => void;
  targetMoistureProfit: number;
  expertMode: boolean;
  selectedBagId?: string;
  clearBag?: () => void;
  renewTotalData?: () => void;
  weight: number;
  targetMoistureData: any;
  totalData: ITotalData;
}
